// extracted by css-extract-rspack-plugin
export default {"form":"form-uMeBPS","errorBanner":"errorBanner-RIVx_N","errorIcon":"errorIcon-ldc7Nd","errorMessage":"errorMessage-pcEGcm"};